import React, { useState } from "react";
import PropTypes from "prop-types";

import ListaDetalle from "./ListaDetalle";
import MenuDetalle from "./MenuDetalle";
import ModalSolicitud from "./ModalSolicitud";
import { VISTA_DETALLE } from "../constants";
import { buscarPorCodigo, menuDetalle } from "../catalogo";
import { itemsDeDetalle } from "../model/presentacion";

/**
 * Lo que no cabe en la pantalla de detalle del solicitante: los estudiantes,
 * el material y el historial. Se abre desde "¡ Mas Informacion !".
 *
 * Va en pestañas, una lista a la vez, con el mismo menu que usan los
 * detalles de los demas modulos (ver MenuDetalle).
 *
 * Presentacion pura: recibe la solicitud tal como la entrega el backend.
 */
const ModalMasInformacion = ({ solicitud, onCerrar }) => {
  const [vista, setVista] = useState(VISTA_DETALLE.ESTUDIANTES);

  const pestanas = menuDetalle(solicitud.tipo_solicitud?.codigo);
  const { vacio } = buscarPorCodigo(pestanas, vista) ?? {};

  return (
    <ModalSolicitud
      titulo="Mas informacion"
      onCerrar={onCerrar}
      menu={
        <MenuDetalle opciones={pestanas} seleccion={vista} onSeleccionar={setVista} />
      }
    >
      <ListaDetalle
        items={itemsDeDetalle(vista, solicitud)}
        vacio={vacio ?? "No hay nada que mostrar"}
      />
    </ModalSolicitud>
  );
};

ModalMasInformacion.propTypes = {
  solicitud: PropTypes.object.isRequired,
  onCerrar: PropTypes.func.isRequired,
};

export default ModalMasInformacion;
